import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { startVersionCheck } from "@/utils/versionCheck";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Reload after a deploy when the app is refocused/resumed (production builds only).
// Compares the bundle's build id with /version.json; never reloads mid-workout/onboarding.
if (process.env.NODE_ENV === "production") {
  startVersionCheck();
}

// ═══════════════════════════════════════════════════════════════
// SERVICE WORKER LIFECYCLE — Hardened for Facebook/Instagram webviews
//
// Timeline:
// 1. index.html <script> runs FIRST → unregisters ALL stale SWs
// 2. React mounts
// 3. This file runs → re-registers the clean no-op SW (normal browsers only)
//
// In-app browsers (FB/IG): SW stays unregistered. No interference possible.
// Normal browsers: Clean no-op SW registered for PWA installability.
// ═══════════════════════════════════════════════════════════════

const ua = navigator.userAgent || '';
const isInAppBrowser = /FBAN|FBAV|Instagram|Line\/|Twitter|Snapchat/i.test(ua);
const isLocalDev = window.location.hostname === 'localhost' && window.location.protocol === 'http:';

// Log environment for diagnostics
console.log('[BODYMAX_SW_INIT]', JSON.stringify({
  isInAppBrowser,
  isLocalDev,
  ua: ua.slice(0, 120),
  url: window.location.href,
}));

// In-app browsers: strip PWA hints that cause bounce-back in WKWebView/CCT
if (isInAppBrowser) {
  document.querySelector('meta[name="apple-mobile-web-app-capable"]')?.remove();
  document.querySelector('link[rel="manifest"]')?.remove();
  console.log('[BODYMAX_SW_INIT] In-app browser: removed manifest + apple-mobile-web-app-capable');
}

// Service worker registration — normal browsers only, after delay
if ('serviceWorker' in navigator && !isInAppBrowser && !isLocalDev) {
  window.addEventListener('load', () => {
    // 1.5s delay ensures index.html's unregister() has fully completed
    setTimeout(() => {
      navigator.serviceWorker.register('/sw.js')
        .then((reg) => {
          console.log('[BODYMAX_SW_INIT] Registered clean SW, scope: ' + reg.scope);
        })
        .catch((err) => {
          console.log('[BODYMAX_SW_INIT] SW registration failed: ' + err.message);
        });
    }, 1500);
  });
} else if (isInAppBrowser) {
  console.log('[BODYMAX_SW_INIT] In-app browser: SW stays unregistered');
}

// PWA install prompt — skip in in-app browsers
if (!isInAppBrowser) {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    window.__bm_deferred_prompt = e;
  });
}
